
import { WorldCountry } from '../types';
import { czechRepublicExpanded } from './czechRepublicExpansion';
import { hungaryExpanded } from './hungaryExpansion';
import { polandData } from './poland';

export const finalEuropeCountries6: WorldCountry[] = [
  czechRepublicExpanded,
  hungaryExpanded,
  polandData
];
